export enum PaymentType {
	INSTALMENT_ADJUSTMENT_SPREAD_EVENLY = 'INSTALMENT_ADJUSTMENT_SPREAD_EVENLY',
	SINGLE_PAYMENT_OFF_SYSTEM_AP = 'SINGLE_PAYMENT_OFF_SYSTEM_AP',
	SINGLE_PAYMENT_PAYMENT_CARD_AP = 'SINGLE_PAYMENT_PAYMENT_CARD_AP',
	INSTALMENT_ADJUSTMENT_NEXT_INSTALMENT = 'INSTALMENT_ADJUSTMENT_NEXT_INSTALMENT',
	SINGLE_PAYMENT_DIRECT_CREDIT_RP = 'SINGLE_PAYMENT_DIRECT_CREDIT_RP',
	SINGLE_PAYMENT_PAYMENT_CARD_RP = 'SINGLE_PAYMENT_PAYMENT_CARD_RP',
	SINGLE_PAYMENT_OFF_SYSTEM_RP = 'SINGLE_PAYMENT_OFF_SYSTEM_RP',
}
